import * as React from "react";
import DisplayFormQualifierAttribute from "./DisplayFormQualifierAttribute";
import { IReferenceValue } from "../../../model/form/ReferenceValue";
import { IFormInputValueValidationError } from "../../../model/validation/FormInputValueValidationError";
import { IFormSectionQualifierPresentationModel } from "../../../presenter/form/model/FormSectionQualifierPresentationModel";
import { IFormQualifierAttributePresentationModel } from "../../../presenter/form/model/FormQualifierAttributePresentationModel";
import { IFormSectionPresentationModel } from "../../../presenter/form/model/FormSectionPresentationModel";
import Text from "antd/lib/typography/Text";
import { Tooltip } from "antd";

export interface State {}

export interface Props {
  formSectionQualifier: IFormSectionQualifierPresentationModel;
  parentSection: IFormSectionPresentationModel;
  translate: any;
  getReferenceValues: any;
  referenceLoading?: boolean;
  referenceValueList?: IReferenceValue[];
  isEditableForm: boolean;
  changeFormAttribute: any;
  validationErrors?: IFormInputValueValidationError[];
  formTypeCode: string;
  formQualifierValidationErrors?: number[];
  allowedFileTypes: string;
}

export default class DisplayFormSectionQualifier extends React.Component<
  Props,
  State
> {
  render() {
    const {
      formSectionQualifier,
      parentSection,
      translate,
      getReferenceValues,
      referenceValueList,
      isEditableForm,
      changeFormAttribute,
      validationErrors,
      formTypeCode,
      allowedFileTypes
    } = this.props;

    const tooltipVisible = formSectionQualifier.tooltip ? true : false;

    const sortQualifierAttributesByOrderNumberDisplay = (
      qualifierAttributeList: IFormQualifierAttributePresentationModel[]
    ) => {
      return qualifierAttributeList.sort((a, b) => {
        return a.orderNumberInsertDisplay - b.orderNumberInsertDisplay;
      });
    };

    const renderAttributesInline = () => {
      let attributeRenderList: JSX.Element[] = [];
      if (formSectionQualifier.attributes) {
        let sortedAttributes = sortQualifierAttributesByOrderNumberDisplay(
          formSectionQualifier.attributes
        );

        sortedAttributes.forEach(
          (
            formQualifierAttribute: IFormQualifierAttributePresentationModel
          ) => {
            attributeRenderList.push(
              <DisplayFormQualifierAttribute
                rowIndex={0}
                key={formQualifierAttribute.id}
                translate={translate}
                attribute={formQualifierAttribute}
                getReferenceValues={getReferenceValues}
                referenceValueList={referenceValueList}
                isEditableForm={isEditableForm}
                changeFormAttribute={changeFormAttribute}
                validationErrors={validationErrors}
                formTypeCode={formTypeCode}
                qualifierCode={formSectionQualifier.qualifierCode}
                width={formSectionQualifier.width}
                allowedFileTypes={allowedFileTypes}
              />
            );
          }
        );
      }
      return attributeRenderList;
    };
    const renderQualifierTitle = () => {
      return (
        <div
          className={
            parentSection.maxNumber === 1
              ? "display-qualifier-title-inline"
              : "qualifier-title-grid"
          }
          style={{ display: "flex", flexDirection: "column" }}
        >
          <h4 style={{ fontWeight: "normal", marginBottom: 0 }}>
            {`${
              formSectionQualifier.orderNumberVisible
                ? `${parentSection.orderNumber}.${formSectionQualifier.orderNumber}`
                : ""
            } ${
              formSectionQualifier.labelVisible && formSectionQualifier.label
                ? formSectionQualifier.label
                : formSectionQualifier.qualifierName
            }`}
            <span style={{ color: "red", marginLeft: 5 }}>
              {formSectionQualifier.isRequiredFlagVisible ? "*" : ""}
            </span>
          </h4>
          <Text style={{ fontSize: 12, fontStyle: "italic" }}>
            {formSectionQualifier.additionalComment || ""}
          </Text>
        </div>
      );
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingTop: 10
        }}
      >
        {tooltipVisible ? (
          <Tooltip title={formSectionQualifier.tooltip}>
            {renderQualifierTitle()}
          </Tooltip>
        ) : (
          renderQualifierTitle()
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%"
          }}
        >
          {renderAttributesInline()}
        </div>
      </div>
    );
  }
}
